import { initialSelectionState } from '../../core/components/annotations/providers/AnnotationsDataInitialState.js';
import { HistogramChartState } from '../types/state.js';

export const initialState: HistogramChartState = {
  filteredSeriesIds: new Set(),
  highlightedSeriesIds: undefined,
  annotations: initialSelectionState,
  zoom: {
    zoomInEnabled: true,
    zoomOutEnabled: false,
  },
  currentDomain: undefined,
  select: undefined,
  interactionMode: 'explore',
  explore: {
    visible: false,
    pinned: false,
    position: undefined,
  },
  toolbar: {
    visible: false,
  },
};
